import { Dialog, IconButton } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PosContext } from "../../shared/PosContext";

import {
    Add,
    FoodBankRounded,
    OpenInNewRounded,
    Receipt,
    SwapHoriz,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { isRoleService } from "../../frappeConfig";
import WidgetsDialogs from "../../pages/Widgets/WidgetsDialogs";
import { dateFormat, dateTimeFormat } from "../../utils/dateUtils";
import { getOrderShortName } from "../../utils/floorUtils";
import CustomerCreationWizard from "../Customer/CustomerCreationWizard";
import SimpleWidgetsHeader from "../SimpleWidgetsHeader/SimpleWidgetsHeader";
import SimpleWidgetsInput from "../SimpleWidgetsInput/SimpleWidgetsInput";
import { useStyles } from "./styles";

const TakeawayOrdersList = ({ onClose, title }) => {
    const classes = useStyles();
    const { takeawayTable, customers, refetchCustomers } =
        useContext(PosContext);

    const { userInfo, isTabsPos, addresses } = useContext(AppContext);

    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [createCustomerDialogOpen, setCreateCustomerDialogOpen] =
        useState(false);

    const [selectedOrder, setSelectedOrder] = useState(null);
    const [widgetsDialogsOpen, setWidgetsDialogsOpen] = useState(false);

    const navigate = useNavigate();

    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setFilteredOrders(orders);
    }, []);

    useEffect(() => {
        if (customers && takeawayTable) {
            const tmpOrders = [];
            const findCustomer = (customer) => {
                const cust = customers.find((i) => i.name === customer);
                return cust;
            };

            Object.values(takeawayTable.orders).forEach((order) => {
                tmpOrders.push({
                    order: order,
                    customer: findCustomer(order.customer),
                });
            });
            setOrders(tmpOrders);
            setFilteredOrders(tmpOrders);
        }
    }, [takeawayTable, customers]);

    useEffect(() => {
        if (!searchText && orders.length > 0) {
            setFilteredOrders(orders);
        } else {
            const tmpOrders = [];
            orders.forEach((order) => {
                const searchFields =
                    order.customer.name +
                    order.customer.mobile_no +
                    getOrderShortName(order.order.name);
                if (
                    searchFields
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                ) {
                    tmpOrders.push(order);
                }
                setFilteredOrders(tmpOrders);
            });
        }
    }, [searchText]);

    const onCloseCreateCustomer = () => {
        setCreateCustomerDialogOpen(false);
    };

    const handleCustomerCreated = (customerData) => {
        refetchCustomers();
        setSearchText(customerData.data.name);
    };

    const newTakeawayOrder = isRoleService(userInfo.role_profile_name)
        ? null
        : {
              callback: () => {
                  navigate("/pos/takeaway");
              },
              Icon: Add,
          };

    const handleCloseDialog = () => {
        setWidgetsDialogsOpen(false);
    };

    const handleListAction = (order) => {
        setSelectedOrder(order.order);
        setWidgetsDialogsOpen(true);
    };

    const handleMoveOrderToTableAction = (order) => {
        const moveTakeAwayOrderEvent = new CustomEvent("requestMoveToTable", {
            detail: { table: takeawayTable },
        });
        document.dispatchEvent(moveTakeAwayOrderEvent);
    };

    const getCustomerAddress = (customer) => {
        const address1 = addresses.find(
            (i) => i.address_title == customer.name
        )?.address_line1;

        const address2 = addresses.find(
            (i) => i.address_title == customer.name
        )?.address_line2;
        return `${address1 ? `${address1}` : ""} ${
            address2 ? `- ${address2}` : ""
        }`;
    };

    return (
        <React.Fragment>
            <SimpleWidgetsHeader
                onClose={onClose}
                Icon={FoodBankRounded}
                title={title || "Takeaway Orders"}
                action={newTakeawayOrder}
            />

            <SimpleWidgetsInput
                isSearch
                placeholder="Search by name or phone #"
                value={searchText}
                onChange={setSearchText}
            />

            <div className={classes.OrderItems}>
                <div className="Orders__List">
                    <div className="Orders__List_RowWrapper">
                        <div className="Orders__List_header">
                            <div>Order</div>
                            <div>Amount</div>
                            <div>Customer</div>
                            <div>Mobile</div>
                            <div>Address</div>
                            <div>Ordered Time</div>
                        </div>
                        <span className="Orders__List_Action">
                            <IconButton style={{ visibility: "hidden" }}>
                                <Receipt />
                            </IconButton>
                        </span>
                    </div>
                </div>
            </div>

            <div className={classes.OrderItems}>
                <div className="Orders__List  md">
                    {takeawayTable &&
                        filteredOrders.map((order) => (
                            <div
                                className="Orders__List_RowWrapper"
                                key={`Takeaway_Orders_${order.order.name}`}
                            >
                                <div
                                    className="Orders__List_item"
                                    onClick={() => {
                                        navigate(
                                            `/pos/takeaway/${order.order.name}`
                                        );
                                    }}
                                >
                                    <div
                                        className=""
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <OpenInNewRounded />
                                        {getOrderShortName(
                                            order.order.name
                                        )}{" "}
                                    </div>
                                    <div>{order.order.amount}₪</div>
                                    <div>{order.customer.name}</div>
                                    <div>{order.customer.mobile_no}</div>
                                    <div>
                                        {getCustomerAddress(order.customer)}
                                    </div>
                                    <div>
                                        {" "}
                                        {`${dateFormat(order.order.creation)
                                            .split("/")
                                            .slice(0, 2)
                                            .join("/")} - ${dateTimeFormat(
                                            order.order.creation.split(" ")[1]
                                        )}`}{" "}
                                    </div>
                                </div>
                                <span className="Orders__List_Action">
                                    <IconButton
                                        onClick={() => handleListAction(order)}
                                    >
                                        <Receipt />
                                    </IconButton>
                                    {!isTabsPos && (
                                        <IconButton
                                            onClick={() =>
                                                handleMoveOrderToTableAction(
                                                    order
                                                )
                                            }
                                        >
                                            <SwapHoriz />
                                        </IconButton>
                                    )}
                                </span>
                            </div>
                        ))}
                </div>
            </div>

            <Dialog maxWidth="xl" open={createCustomerDialogOpen}>
                <CustomerCreationWizard
                    onClose={onCloseCreateCustomer}
                    onConfirm={handleCustomerCreated}
                />
            </Dialog>

            {/* Payment Dialog */}
            <WidgetsDialogs
                open={widgetsDialogsOpen}
                onClose={handleCloseDialog}
                order={selectedOrder}
                table={takeawayTable}
                isTakeaway={true}
                onInvoiceClose={handleCloseDialog}
            ></WidgetsDialogs>
        </React.Fragment>
    );
};

export default TakeawayOrdersList;
